import { combineReducers } from "redux";
import flightBookingReducer from "./flight/reducer";

const rootReducer = combineReducers({
  flightBooking: flightBookingReducer,
});

export default rootReducer;
